<!--
 * @Author: game.pluto.com 66291979@qq.com
 * @Date: 2024-06-26 15:05:11
 * @LastEditors: guojia 66291979@qq.com
 * @LastEditTime: 2024-09-06 18:35:41
 * @FilePath: /lobby/src/components/ChangePassWord.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <van-popup
    class="popup_box"
    v-model:show="showValue"
    round
    :style="{ padding: '64px' }"
    :closeOnClickOverlay="false"
    :transition-appear="true"
  >
    <div @click="cancel" class="popup_close close_center"><span></span></div>
    <div class="popup">
      <h1>{{ $t('password.title').toUpperCase() }}</h1>
      <InputField
        v-model="oldPassword"
        :placeholder="$t('password.old')"
        style="margin-bottom: 0.2rem"
        :validate="validatePassword"
        :focus="usernameFocus"
        type="password"
        :enter="
          () => {
            passwordFocus = true
          }
        "
      />
      <a @click="onForget" class="forget">{{ $t('login.forget') }}</a>
      <InputField
        v-model="newPassword"
        :placeholder="$t('password.new')"
        :validate="validatePassword"
        type="password"
        style="margin-bottom: -0.1rem"
        :focus="passwordFocus"
        :enter="
          () => {
            passwordFocus = false
            onConfirm()
          }
        "
      />
      <p style="text-align: center; margin-bottom: 1rem">{{ $t('password.tips') }}</p>
      <div class="btn_100 btn_yellow" @click="onConfirm">{{ $t('button.confirm') }}</div>
    </div>
    <div class="popup_footer" @click="onChat">{{ $t('register.service') }}</div>
  </van-popup>
</template>

<script>
import InputField from '@/components/InputField.vue'
import { BUS, POPUP } from '@/event/EventCenter'
import { useUserStore } from '@/stores/user'
import { mapActions } from 'pinia'
import { showLoadingToast, showSuccessToast } from 'vant'
import { validatePassword } from '@/common/valiadate.js'
export default {
  name: 'LobbyChangePassWord',
  components: {
    InputField
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      showValue: false,
      oldPassword: '',
      newPassword: '',
      usernameFocus: true,
      passwordFocus: false
    }
  },
  watch: {
    show(newValue) {
      if (this.showValue == newValue) {
        return
      }
      this.showValue = newValue
    }
  },
  mounted() {
    this.showValue = this.show
  },

  methods: {
    validatePassword,
    ...mapActions(useUserStore, { changePassWord: 'changePassWord' }),
    onForget() {
      this.$bus.$emit(BUS.SHOW_POPUP, {
        from: 'changepassword',
        to: POPUP.RESET_PASSWORD,
        show: true
      })
    },
    check() {
      return (
        this.validatePassword(this.newPassword).length <= 0 &&
        this.validatePassword(this.oldPassword).length <= 0
      )
    },
    onConfirm() {
      this.$bus.$emit(BUS.CHECK_INPUT_VALUE, 'register')
      if (!this.check()) {
        return
      }
      showLoadingToast({
        message: '',
        forbidClick: true,
        duration: 0
      })
      this.changePassWord(this.oldPassword, this.newPassword).then((res) => {
        if (res) {
          showSuccessToast({
            message: this.$t('password.success'),
            wordBreak: 'break-word',
            onClose: () => {
              this.cancel()
            },
            duration: 3000
          })
        }
      })
    },
    onChat() {
      this.$bus.$emit(BUS.SHOW_CHAT)
    }
  }
}
</script>

<style lang="scss" scoped>
.popup_box {
  width: 6.5rem;
  height: auto;
  margin: 0 auto;
  padding: 0 !important;
  overflow: visible !important;
  border: solid 0.04rem transparent;
  border-radius: 0.16rem;
  background-color: #000;
  background-image: linear-gradient(#000, #000),
    linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  text-align: center;
  z-index: 100;
  font-size: 0.24rem;

  .popup {
    width: 81%;
    height: auto;
    border-radius: 12px;
    display: block;
    padding: 5%;
    margin: 0 auto;

    h1 {
      font-size: 0.38rem;
      line-height: 0.4rem;
      margin: 0.1rem 0;
      font-weight: bold;
      color: #ffddac;
      margin-bottom: 1.2rem;
    }
    h2 {
      font-size: 0.24rem;
      line-height: 0.3rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }
    p {
      line-height: 0.32rem;
      margin: 0;
      color: #fff;
    }

    .forget {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 0.4rem;
      width: 92%;
      font-weight: 400;
      font-size: 0.23rem;
      color: #ffddac;
      text-decoration-line: underline;
      cursor: pointer;
      text-align: right;
    }

    .btn_100 {
      line-height: 0.66rem;
      text-align: center;
      border-radius: 0.33rem;
      margin: 0.4rem 0;
    }
    .btn_yellow {
      color: #fff;
      background-color: #aa884a;
      border: 2px solid #aa884a;
    }
  }
  .popup_footer {
    text-align: center;
    margin: 1rem 0 0 0;
    padding: 0.3rem 0;
    height: auto;
    width: 100%;
    color: #ffddac;
    overflow: hidden;
    text-decoration-line: underline;
    cursor: pointer;
  }

  .close_center {
    display: flex !important;
    margin-top: -0.5rem !important;
    justify-content: center;
    align-items: flex-start;
  }
  .popup_close {
    height: 0.8rem;
    width: 0.8rem;
    border-radius: 50%;
    background-color: #000;
    border: solid 4px transparent;
    background-image: linear-gradient(#000, #000),
      linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    margin-top: -1.2rem;
    text-align: center;
    position: absolute;
    display: block;
    z-index: 2;
    margin-left: 90%;

    span {
      display: inline-block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #aa884a;
      background-image: linear-gradient(
        130deg,
        #dfc572 0%,
        #916c38 50%,
        #825c2d 50.1%,
        #aa884a 100%
      );
      transform: rotate(45deg);
      margin-top: 0.355rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #aa884a;
      background-image: linear-gradient(
        130deg,
        #dfc572 0%,
        #916c38 50%,
        #825c2d 50.1%,
        #aa884a 100%
      );
      transform: rotate(-90deg);
    }
  }
}
</style>
